module.exports = __webpack_public_path__ + "img/installation-ios.e61a95f9.svg";